export default "__VITE_ASSET__d075fe95__"